import { ChangeEvent } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';

import styles from './PointLine.module.scss';

interface IPointLineProps {
  id: string | number;
  name: string;
  groupName: string;
  isActive?: boolean;
  withFunctionsButton?: boolean;
  isEnable?: boolean;
  isWatchOnly?: boolean;
  isEditDisable?: boolean;
  isCheckboxDisable?: boolean;
  isLockedByTerritory?: boolean;
  onCheckboxChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFunctionsButtonClick?: () => void;
  onDelete?: () => void;
}

export const PointLine = ({
  id,
  name,
  groupName,
  isActive = false,
  withFunctionsButton,
  isEnable,
  isWatchOnly,
  isEditDisable,
  isCheckboxDisable,
  isLockedByTerritory,
  onCheckboxChange,
  onFunctionsButtonClick,
  onDelete,
}: IPointLineProps) => (
  <div className={styles.Section}>
    <div className={styles.SectionContent}>
      {typeof isEnable === 'boolean' && !isEnable && <div className={styles.SectionWarning}>Устаревшие данные!</div>}
      <Checkbox
        id={id?.toString()}
        name={groupName}
        label={name}
        type="radio"
        theme="system"
        size="medium"
        checked={isActive}
        disabled={isCheckboxDisable}
        readOnly={isCheckboxDisable}
        onChange={onCheckboxChange}
      />
      {isLockedByTerritory && (
        <div className={styles.FillInProcessMessage}>
          Территориальный орган не может выбрать значение «Генеральная прокуратура Российской Федерации» в качестве
          связанной организации
        </div>
      )}
    </div>
    {!isWatchOnly && (
      <div className={styles.SectionButtons}>
        {withFunctionsButton && (
          <>
            <Button
              className={styles.FunctionsButton}
              type="button"
              color="primary"
              text="Показать функции"
              variant="link"
              onClick={onFunctionsButtonClick}
            />
            <div className={styles.VersionAvailable}>Для ЕРП</div>
          </>
        )}
        {!isEditDisable && <CloseButton onClick={onDelete} />}
      </div>
    )}
  </div>
);
